import { ref } from 'vue';
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-038ca4c4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "upload-info-modal-content"
};
const _hoisted_2 = {
  key: 0,
  class: "upload-title-content"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "点击上传", -1));
const _hoisted_4 = {
  class: "flex-list"
};
const _hoisted_5 = {
  key: 0,
  class: "upload-title-content"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "点击上传", -1));
const _hoisted_7 = {
  style: {
    "text-align": "right"
  }
};
const _hoisted_8 = ["src"];
import { uploadAuditScreenshot, translateRemark, submitPromotionImage, submitAuditScreenshot, submitRemark, getProductMedia } from '@/api/goodsInfo';
import { message } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'UploadInfoModal',
  props: {
    dbtId: null,
    modalVisible: {
      type: Boolean
    },
    prodChnl: null
  },
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const infoform = ref();
    const infoItem = ref({});
    const fileList = ref([]); // 截图
    const fileurl = ref('');
    const fileurl1 = ref('');
    const fileList1 = ref([]); // 推广图片
    const spinning = ref(false); // 加载
    let mediaRequestId = 0;
    const infoForm = ref({
      screenshotReqVos: [{
        zhHans: '',
        enUs: '',
        id: 0,
        prodId: 0,
        prodType: 0
      }]
    });
    const previewImage = ref('');
    const previewVisible = ref(false);
    const previewTitle = ref('');
    function getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    }
    const handleCancel = () => {
      previewVisible.value = false;
      previewTitle.value = '';
    };
    // 预览图片
    const reUpload = async file => {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      previewImage.value = file.url || file.preview;
      previewVisible.value = true;
      previewTitle.value = file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
    };
    // 审核截屏上传
    const beforeUpload = file => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        message.error('只能上传 JPG/PNG 文件!');
        return false;
      }
      // 图片大小不能超过 5mb
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isLt2M && props.prodChnl == 'harmony') {
        message.error('图片大小不能超过 5MB!');
        return false;
      }
      // fileList.value = []
      // return isJpgOrPng && isLt2M
      return new Promise((resolve, reject) => {
        const width = 1242;
        const height = 2688;
        const _URL = window.URL || window.webkitURL;
        const img = new Image();
        img.src = _URL.createObjectURL(file);
        img.onload = () => {
          // 只有鸿蒙限制照片尺寸
          if ((img.width < 640 || img.height < 920) && props.prodChnl == 'harmony') {
            message.error(`上传尺寸至少为640*920`);
            return false;
          }
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);
          // 将canvas上的图片转换为Blob对象
          canvas.toBlob(blob => {
            if (blob === null) {
              reject(new Error('无法创建图片Blob对象'));
              return; // 如果blob为null，则不继续执行后面的代码
            }
            // 创建一个新的File对象，用于上传
            const type = 'image/jpeg';
            // if (file.type === 'image/png') {
            //   type = 'image/png'
            // }
            // 把file.name 里面.png 后缀的改成.jpg 后缀
            const newname = file.name.replace(/\.[^/.]+$/, '.jpg');
            const fileOfBlob = new File([blob], newname, {
              type
            });
            // 将处理后的图片添加到上传列表
            fileList.value = [...(fileList.value || []), fileOfBlob];
            resolve(fileOfBlob); // 使用处理后的图片对象进行上传
          }, 'image/jpeg');
        };
        img.onerror = () => {
          reject(new Error('图片加载失败'));
        };
      });
      // 判断图片宽高是否为 1242*2208 或者 1242*2688
      // return (async () => {
      //   return new Promise((resolve, reject) => {
      //     const width = 1242;
      //     const height = 2208;
      //     const _URL = window.URL || window.webkitURL;
      //     const img = new Image();
      //     img.src = _URL.createObjectURL(file);
      //     img.onload = function () {
      //       console.log(
      //         img.width,
      //         img.height,
      //         `上传尺寸${width}px * ${height}px!`
      //       );
      //       if (img.width != width || (img.height != height && img.height != 2688)) {
      //         message.error(`上传尺寸为${width}px * ${2208}px 或 ${width}px * 2688px!`);
      //         reject();
      //       } else {
      //         resolve(true);
      //       }
      //     };
      //   });
      // })()
    };
    const handleChange = info => {
      if (info.file.status === 'done') {
        fileurl.value = URL.createObjectURL(info.file.originFileObj);
        fileList.value = [];
        fileList.value.push(info.file);
      }
    };
    const customRequest = async item => {
      const {
        file,
        onError,
        onSuccess
      } = item;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('businessType', 'APPLE_SCREEN_APPROVAL');
      formData.append('businessId', infoItem.value.prodId);
      try {
        spinning.value = true;
        const res = await uploadAuditScreenshot(formData);
        if (res.code == 0) {
          onSuccess(res.data);
        } else {
          onError();
          message.error(res.msg);
        }
      } catch (e) {} finally {
        spinning.value = false;
      }
    };
    // 推广图片截屏
    const beforeUpload1 = file => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        message.error('只能上传 JPG/PNG 文件!');
        return false;
      }
      // 图片大小不能超过 10mb
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        message.error('图片大小不能超过 10mb!');
        return false;
      }
      // 判断图片宽高是否为 1024*1024
      return (async () => {
        return new Promise((resolve, reject) => {
          const width = 1024;
          const height = 1024;
          const _URL = window.URL || window.webkitURL;
          const img = new Image();
          img.src = _URL.createObjectURL(file);
          img.onload = function () {
            if (img.width != width || img.height != height) {
              message.error(`上传尺寸为${width}px * ${height}px `);
              fileList1.value = [];
              reject();
            } else {
              resolve(true);
            }
          };
        });
      })();
    };
    const handleChange1 = info => {
      if (!info.file.status) {
        fileList1.value = [];
      }
      if (info.file.status === 'done') {
        fileurl1.value = URL.createObjectURL(info.file.originFileObj);
        fileList1.value = [];
        fileList1.value.push(info.file);
      }
    };
    const customRequest1 = async item => {
      const {
        file,
        onError,
        onSuccess
      } = item;
      const formData = new FormData();
      formData.append('file', file);
      formData.append('businessType', 'APPLE_SCREEN_APPROVAL');
      formData.append('businessId', infoItem.value.prodId);
      try {
        spinning.value = true;
        const res = await uploadAuditScreenshot(formData);
        if (res.code == 0) {
          onSuccess(res.data);
        } else {
          onError();
          message.error(res.msg);
        }
      } catch (e) {} finally {
        spinning.value = false;
      }
    };
    // 翻译
    const translate = async () => {
      try {
        spinning.value = true;
        const params = {
          remarkTranslates: infoForm.value.screenshotReqVos.map(item => {
            return {
              ...item
            };
          })
        };
        const res = await translateRemark(params);
        if (res.code == 0) {
          infoForm.value.screenshotReqVos = res.data.remarkTranslatedResult;
        }
      } catch (e) {} finally {
        spinning.value = false;
      }
    };
    // 提交截图
    const submitUpload = () => {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const params = {
            dbtId: props.dbtId,
            prodChnl: props.prodChnl,
            screenshotReqVos: [{
              prodId: infoItem.value.prodId,
              remoteFileName: fileList.value[0].response.remoteFileName,
              fileUrl: fileList.value[0].response.fileUrl,
              fileSize: fileList.value[0].response.fileSize
            }],
            prodInfos: [{
              prodId: infoItem.value.prodId,
              prodType: infoItem.value.prodType,
              id: infoItem.value.id
            }]
          };
          const res = await submitAuditScreenshot(params);
          if (res.code == 0) {
            if (res.data.failProdIds.length > 0) {
              let str = '';
              res.data.failProdIds.forEach(item => {
                // 换行
                str += item + '\n';
              });
              // message.error(str + '上传失败')
              reject(str + '上传失败');
            } else {
              resolve('上传截图成功');
              // message.success('上传截图成功')
            }
          } else {
            // message.error(res.msg)
            reject(res.msg);
          }
        } catch (error) {
          reject('上传截屏失败: ' + error);
        }
      });
    };
    // 提交备注
    const subRemark = async () => {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const params = {
            dbtId: props.dbtId,
            prodChnl: props.prodChnl,
            screenshotReqVos: infoForm.value.screenshotReqVos.map(item => {
              return {
                id: infoItem.value.id,
                ...item
              };
            })
          };
          const res = await submitRemark(params);
          if (res.code == 0) {
            // message.success('上传备注成功')
            resolve('上传备注成功');
          } else {
            // message.error(res.msg)
            reject(res.msg);
            // throw new Error(res.msg);
          }
        } catch (error) {
          reject('提交备注失败: ' + error);
        }
      });
    };
    // 提交推广图片
    const submitTgPic = () => {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const params = {
            dbtId: props.dbtId,
            id: infoItem.value.id,
            prodType: infoItem.value.prodType,
            prodChnl: props.prodChnl,
            submitPromotionInfo: {
              fileSize: fileList1.value[0].response.fileSize,
              fileUrl: fileList1.value[0].response.fileUrl,
              prodId: infoItem.value.prodId,
              remoteFileName: fileList1.value[0].response.remoteFileName
            }
          };
          const res = await submitPromotionImage(params);
          if (res.code == 0) {
            // message.success('上传推广图片成功')
            // emit('update:modalVisible', false)
            resolve('上传推广图片成功');
          } else {
            reject(res.msg);
          }
        } catch (error) {
          reject('上传推广图片失败: ' + error);
        }
      });
    };
    //
    const submitModal = async () => {
      var _infoItem$value$scree, _infoItem$value$audit, _infoItem$value$audit2, _infoItem$value$promo;
      spinning.value = true;
      const pms = [];
      if (fileList.value.length != 0 && fileurl.value !== ((_infoItem$value$scree = infoItem.value.screenShot) === null || _infoItem$value$scree === void 0 ? void 0 : _infoItem$value$scree.fileUrl)) {
        pms.push(submitUpload().then(result => ({
          status: 'fulfilled',
          result
        })).catch(error => ({
          status: 'rejected',
          error
        })));
      }
      if (infoForm.value.screenshotReqVos[0].zhHans !== ((_infoItem$value$audit = infoItem.value.auditRemarks) === null || _infoItem$value$audit === void 0 ? void 0 : _infoItem$value$audit.split('\n')[0]) || infoForm.value.screenshotReqVos[0].enUs !== ((_infoItem$value$audit2 = infoItem.value.auditRemarks) === null || _infoItem$value$audit2 === void 0 ? void 0 : _infoItem$value$audit2.split('\n')[1])) {
        pms.push(subRemark().then(result => ({
          status: 'fulfilled',
          result
        })).catch(error => ({
          status: 'rejected',
          error
        })));
      }
      if (fileList1.value.length != 0 && fileurl1.value !== ((_infoItem$value$promo = infoItem.value.promotionPic) === null || _infoItem$value$promo === void 0 ? void 0 : _infoItem$value$promo.fileUrl)) {
        pms.push(submitTgPic().then(result => ({
          status: 'fulfilled',
          result
        })).catch(error => ({
          status: 'rejected',
          error
        })));
      }
      const results = await Promise.all(pms);
      const allFulfilled = results.every(result => result.status === 'fulfilled');
      if (allFulfilled) {
        message.success('提交成功');
        emit('update:modalVisible', false);
        emit('searchData');
      } else {
        results.forEach(result => {
          if (result.status === 'rejected') {
            message.error(result.error);
          }
        });
      }
      spinning.value = false;
    };
    const createUploadFile = (media, uid) => ({
      uid,
      name: media.remoteFileName,
      status: 'done',
      url: media.fileUrl,
      response: media
    });
    const openModal = async item => {
      const requestId = ++mediaRequestId;
      infoItem.value = {
        ...item
      };
      fileList.value = [];
      fileList1.value = [];
      fileurl.value = '';
      fileurl1.value = '';
      if (item) {
        // 回显备注
        infoForm.value.screenshotReqVos[0] = {
          zhHans: '',
          enUs: '',
          id: item.id,
          prodId: item.prodId,
          prodType: item.prodType
        };
        if (item.auditRemarks && props.prodChnl == 'apple') {
          const strs = item.auditRemarks.split('\n');
          infoForm.value.screenshotReqVos[0].zhHans = strs[1];
          infoForm.value.screenshotReqVos[0].enUs = strs[0];
        } else {
          infoForm.value.screenshotReqVos[0].zhHans = item.auditRemarks;
        }
      }
      emit('update:modalVisible', true);
      if (!(item !== null && item !== void 0 && item.screenShot) && !(item !== null && item !== void 0 && item.promotionPic)) return;
      spinning.value = true;
      try {
        const res = await getProductMedia({
          id: item.id
        });
        if (requestId !== mediaRequestId || infoItem.value.id !== item.id) return;
        if (res.code != 0) {
          message.error(res.msg || '图片信息加载失败');
          return;
        }
        const media = res.data || {};
        infoItem.value = {
          ...infoItem.value,
          screenShot: media.screenShot || null,
          promotionPic: media.promotionPic || null
        };
        if (media.screenShot) {
          fileList.value = [createUploadFile(media.screenShot, '-1')];
          fileurl.value = media.screenShot.fileUrl;
        }
        if (media.promotionPic) {
          fileList1.value = [createUploadFile(media.promotionPic, '-2')];
          fileurl1.value = media.promotionPic.fileUrl;
        }
      } catch (error) {
        if (requestId === mediaRequestId) {
          message.error('图片信息加载失败');
        }
      } finally {
        if (requestId === mediaRequestId) {
          spinning.value = false;
        }
      }
    };
    const closeModal = () => {
      if (spinning.value) return;
      mediaRequestId++;
      emit('update:modalVisible', false);
      fileList.value = [];
      fileurl.value = '';
      infoForm.value = {
        screenshotReqVos: [{
          zhHans: '',
          enUs: '',
          id: 0,
          prodId: 0,
          prodType: 0
        }]
      };
      fileList1.value = [];
      fileurl1.value = '';
    };
    expose({
      openModal,
      closeModal
    });
    return (_ctx, _cache) => {
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_upload = _resolveComponent("a-upload");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.modalVisible,
        centered: "",
        title: "上传信息",
        width: "550px",
        footer: null,
        onCancel: closeModal
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_spin, {
          spinning: spinning.value
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form, {
            name: "infoForm",
            model: infoForm.value,
            ref_key: "infoform",
            ref: infoform
          }, {
            default: _withCtx(() => [_createVNode(_component_a_form_item, {
              label: "审核截屏"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_upload, {
                "file-list": fileList.value,
                "onUpdate:file-list": _cache[0] || (_cache[0] = $event => fileList.value = $event),
                name: "avatar",
                "list-type": "picture-card",
                class: "avatar-uploader",
                "before-upload": beforeUpload,
                onChange: handleChange,
                customRequest: customRequest,
                showUploadList: {
                  showPreviewIcon: true,
                  showRemoveIcon: true
                },
                onPreview: reUpload
              }, {
                default: _withCtx(() => [fileList.value.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_svg_icon, {
                  "icon-class": "add_no_color",
                  "class-name": "upload-icon"
                }), _hoisted_3])) : _createCommentVNode("", true)]),
                _: 1
              }, 8, ["file-list"])]),
              _: 1
            }), _createVNode(_component_a_form_item, {
              label: "审核备注"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_a_input, {
                value: infoForm.value.screenshotReqVos[0].zhHans,
                "onUpdate:value": _cache[1] || (_cache[1] = $event => infoForm.value.screenshotReqVos[0].zhHans = $event),
                placeholder: "请输入中文备注",
                maxlength: props.prodChnl == 'apple' ? 400 : 200
              }, null, 8, ["value", "maxlength"]), props.prodChnl == 'apple' ? (_openBlock(), _createBlock(_component_a_button, {
                key: 0,
                ghost: "",
                type: "primary",
                class: "robot-btn",
                onClick: translate
              }, {
                icon: _withCtx(() => [_createVNode(_component_svg_icon, {
                  "icon-class": "robot",
                  "class-name": "robot-icon"
                })]),
                default: _withCtx(() => [_createTextVNode(" 智能翻译 ")]),
                _: 1
              })) : _createCommentVNode("", true)]), props.prodChnl == 'apple' ? (_openBlock(), _createBlock(_component_a_input, {
                key: 0,
                value: infoForm.value.screenshotReqVos[0].enUs,
                "onUpdate:value": _cache[2] || (_cache[2] = $event => infoForm.value.screenshotReqVos[0].enUs = $event),
                placeholder: "请输入英文备注"
              }, null, 8, ["value"])) : _createCommentVNode("", true)]),
              _: 1
            }), props.prodChnl == 'apple' ? (_openBlock(), _createBlock(_component_a_form_item, {
              key: 0,
              label: "推广图片"
            }, {
              default: _withCtx(() => [_createVNode(_component_a_upload, {
                "file-list": fileList1.value,
                "onUpdate:file-list": _cache[3] || (_cache[3] = $event => fileList1.value = $event),
                "list-type": "picture-card",
                class: "avatar-uploader",
                showUploadList: {
                  showPreviewIcon: true,
                  showRemoveIcon: true
                },
                "before-upload": beforeUpload1,
                onChange: handleChange1,
                customRequest: customRequest1,
                onPreview: reUpload
              }, {
                default: _withCtx(() => [fileList1.value.length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_svg_icon, {
                  "icon-class": "add_no_color",
                  "class-name": "upload-icon"
                }), _hoisted_6])) : _createCommentVNode("", true)]),
                _: 1
              }, 8, ["file-list"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["model"]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_a_button, {
            onClick: closeModal,
            style: {
              "margin-right": "8px"
            }
          }, {
            default: _withCtx(() => [_createTextVNode("取消")]),
            _: 1
          }), _createVNode(_component_a_button, {
            type: "primary",
            onClick: submitModal
          }, {
            default: _withCtx(() => [_createTextVNode("提交")]),
            _: 1
          })])]),
          _: 1
        }, 8, ["spinning"]), _createVNode(_component_a_modal, {
          open: previewVisible.value,
          title: previewTitle.value,
          footer: null,
          onCancel: handleCancel
        }, {
          default: _withCtx(() => [_createElementVNode("img", {
            alt: "example",
            style: {
              "width": "100%"
            },
            src: previewImage.value
          }, null, 8, _hoisted_8)]),
          _: 1
        }, 8, ["open", "title"])])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});